export function welcome_banner(state){
    return state.welcome_banner
}